import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import './Auth.css';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [registered, setRegistered] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await register(email, password, name);
    if (result.success) {
      // Если требуется подтверждение email, показываем сообщение
      if (result.email_verification_required) {
        setRegistered(true);
      } else {
        // Если токен выдан (старая версия API), перенаправляем
        navigate('/tasks', { replace: true });
      }
    }
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>SAVEL'EV CRM</h1>
          <h2>Регистрация</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Имя</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="input"
              placeholder="Ваше имя"
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="input"
              placeholder="your@email.com"
            />
          </div>
          <div className="form-group">
            <label>Пароль</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="input"
              placeholder="••••••••"
              minLength="8"
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Регистрация...' : 'Зарегистрироваться'}
          </button>
        </form>
        {!registered && (
          <p className="auth-footer">
            Уже есть аккаунт? <Link to="/login">Войти</Link>
          </p>
        )}
        {registered && (
          <div className="verification-status success">
            <div className="success-icon">📧</div>
            <p>Проверьте почту</p>
            <p className="info-message">
              Мы отправили ссылку подтверждения на {email}. До подтверждения войти в аккаунт нельзя.
            </p>
            <div className="verification-actions">
              <Link to="/login" className="btn btn-primary">Перейти к входу</Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Register;
